import React from 'react';
import { cn } from '@heroui/react';

export interface PageProps {
  /**
   * 页面内容
   */
  children: React.ReactNode;
  /**
   * 自定义类名
   */
  className?: string;
  /**
   * 是否启用安全区域（iOS notch 等）
   * @default true
   */
  safeArea?: boolean;
  /**
   * 是否启用滚动
   * @default true
   */
  scrollable?: boolean;
  /**
   * 背景色
   */
  backgroundColor?: string;
  /**
   * 是否有底部 TabBar（用于调整 padding-bottom）
   * @default false
   */
  hasTabBar?: boolean;
  /**
   * 是否有顶部 NavBar（用于调整 padding-top）
   * @default false
   */
  hasNavBar?: boolean;
}

/**
 * 移动端页面容器组件
 * 
 * 特性：
 * - ✅ 处理安全区域（iOS notch、Android 状态栏等）
 * - ✅ 支持滚动控制
 * - ✅ 自动处理 TabBar 和 NavBar 的间距
 * - ✅ 响应式设计
 */
export function Page({
  children,
  className,
  safeArea = true,
  scrollable = true,
  backgroundColor = 'var(--background)',
  hasTabBar = false,
  hasNavBar = false,
}: PageProps) {
  return (
    <div
      className={cn(
        'relative w-full min-h-screen',
        safeArea && 'safe-area-inset',
        !scrollable && 'overflow-hidden',
        className
      )}
      style={{
        backgroundColor,
        paddingTop: hasNavBar ? 'var(--navbar-height, 44px)' : safeArea ? 'env(safe-area-inset-top)' : 0,
        paddingBottom: hasTabBar ? 'var(--tabbar-height, 50px)' : safeArea ? 'env(safe-area-inset-bottom)' : 0,
        paddingLeft: safeArea ? 'env(safe-area-inset-left)' : 0,
        paddingRight: safeArea ? 'env(safe-area-inset-right)' : 0,
      }}
    >
      {scrollable ? (
        <div className="h-full overflow-y-auto overflow-x-hidden">
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  );
}
